// app/javascript/controllers/modal_trigger_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    id: String, // modal element id
    url: String, // optional dynamic URL to load into the modal
    reset: { type: Boolean, default: true }, // force reload even if same URL
    forBlocknote: { type: Boolean, default: false }, // only respond to mediaBrowserRequested events if true
  };

  connect() {
    // Only listen for media browser requests if this controller is for BlockNote
    if (this.forBlocknoteValue) {
      this.mediaBrowserRequestHandler = this.handleMediaBrowserRequest.bind(this);
      document.addEventListener("mediaBrowserRequested", this.mediaBrowserRequestHandler);
    }
  }

  disconnect() {
    // Cleanup event listener
    if (this.mediaBrowserRequestHandler) {
      document.removeEventListener("mediaBrowserRequested", this.mediaBrowserRequestHandler);
    }
  }

  handleMediaBrowserRequest(event) {
    // Extra guard: if this instance is not for BlockNote, ignore
    if (!this.forBlocknoteValue) return;

    // Ensure only the first interested listener handles this request
    if (event.detail && event.detail.__handled) return;
    if (event.detail) event.detail.__handled = true;

    // Store the block context for later use when selection is made
    this.currentBlockType = event.detail.blockType;
    this.currentBlockId = event.detail.blockId;

    // Open the media browser modal
    this.open();
  }

  open() {
    const el = document.getElementById(this.idValue);
    if (!el) return;

    el.dispatchEvent(
      new CustomEvent("modal:open", {
        bubbles: true,
        detail: {
          src: this.hasUrlValue ? this.urlValue : null,
          reset: this.resetValue,
          blockType: this.currentBlockType, // Pass block type to modal
          blockId: this.currentBlockId, // Pass block ID for unique identification
        },
      }),
    );
  }

  close() {
    const el = document.getElementById(this.idValue);
    if (el) el.dispatchEvent(new CustomEvent("modal:close", { bubbles: true }));

    // Clear block type after closing
    this.currentBlockType = null;
  }
}
